<template>
    <div class="md:ml-10 ml-auto">
        <button @click.prevent="onTrashClick"
                class="outline-none flex flex-row justify-center iphone-border
                                    items-center h-6 w-6 -mt-0 md:-ml-8" id="trashButton">
            <img class="mr-2 w-5 h-5 md:w-auto md:h-auto" src="@/assets/SVG/trash-bin.svg"/>
        </button>
    </div>
</template>

<script>
export default {
  name: 'trash-bin',
  props: ['delPlace'],
  methods: {
    onTrashClick() {
      if (this.delPlace) {
        this.$emit('delete_element', this.delPlace.dateIdx, this.delPlace.placeIdx);
      } else this.$emit('delete_element');
    },
  },
};


</script>

<style scoped>

</style>
